export const messages = {
  en: {
    reportCustomManage: {
      searchTitle: 'Search Conditions',
      reportTitle: 'Report Information',
      customId: 'Report ID',
      groupId: 'Report Group',
      title: 'Option Title',
      seq: 'Sequence',
      remark: 'Description',
      operation: 'Operation',
      search: 'Search',
      reset: 'Reset',
      addReport: 'Add Report',
      relateComponent: 'Relate Component',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel'
    },
    addReportCustom: {
      title: 'Add Report',
      group: 'Report Group',
      required: 'Required',
      selectGroup: 'Please select report group',
      optionTitle: 'Option Title',
      inputTitle: 'Please input option title',
      sequence: 'Sequence',
      inputSeq: 'Please input sequence',
      description: 'Description',
      inputDesc: 'Please input description',
      save: 'Save'
    },
    editReportCustom: {
      title: 'Edit Report',
      group: 'Report Group',
      required: 'Required',
      selectGroup: 'Please select report group',
      optionTitle: 'Option Title',
      inputTitle: 'Please input option title',
      sequence: 'Sequence',
      inputSeq: 'Please input sequence',
      description: 'Description',
      inputDesc: 'Please input description',
      save: 'Save'
    },
    deleteReportCustom: {
      title: 'Confirm Operation',
      confirmDelete: 'Confirm to delete report',
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    reportCustomManage: {
      searchTitle: '查询条件',
      reportTitle: '报表信息',
      customId: '报表编号',
      groupId: '报表组',
      title: '选项标题',
      seq: '排序',
      remark: '描述',
      operation: '操作',
      search: '查询',
      reset: '重置',
      addReport: '添加报表',
      relateComponent: '关联组件',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消'
    },
    addReportCustom: {
      title: '添加报表',
      group: '报表组',
      required: '必填',
      selectGroup: '请选择报表组',
      optionTitle: '选项标题',
      inputTitle: '请填写选项标题',
      sequence: '排序',
      inputSeq: '请填写排序',
      description: '描述',
      inputDesc: '请填写描述',
      save: '保存'
    },
    editReportCustom: {
      title: '修改报表',
      group: '报表组',
      required: '必填',
      selectGroup: '请选择报表组',
      optionTitle: '选项标题',
      inputTitle: '请填写选项标题',
      sequence: '排序',
      inputSeq: '请填写排序',
      description: '描述',
      inputDesc: '请填写描述',
      save: '保存'
    },
    deleteReportCustom: {
      title: '请确认您的操作',
      confirmDelete: '确定删除报表',
      cancel: '点错了',
confirm: '確認刪除'
    }
  },
  'zh-TW': {
    reportCustomManage: {
      searchTitle: '查詢條件',
      reportTitle: '報表信息',
      customId: '報表編號',
      groupId: '報表組',
      title: '選項標題',
      seq: '排序',
      remark: '描述',
      operation: '操作',
      search: '查詢',
      reset: '重置',
      addReport: '添加報表',
      relateComponent: '關聯組件',
      edit: '修改',
      delete: '刪除',
      confirmDelete: '確認刪除',
      cancel: '取消'
    },
    addReportCustom: {
      title: '添加報表',
      group: '報表組',
      required: '必填',
      selectGroup: '請選擇報表組',
      optionTitle: '選項標題',
      inputTitle: '請填寫選項標題',
      sequence: '排序',
      inputSeq: '請填寫排序',
      description: '描述',
      inputDesc: '請填寫描述',
      save: '保存'
    },
    editReportCustom: {
      title: '修改報表',
      group: '報表組',
      required: '必填',
      selectGroup: '請選擇報表組',
      optionTitle: '選項標題',
      inputTitle: '請填寫選項標題',
      sequence: '排序',
      inputSeq: '請填寫排序',
      description: '描述',
      inputDesc: '請填寫描述',
      save: '保存'
    },
    deleteReportCustom: {
      title: '請確認您的操作',
      confirmDelete: '確定刪除報表',
      cancel: '點錯了',
      confirm: '確認刪除'
    }
  }
}